var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-blacker-content-box',{attrs:{"is-loading-process":_vm.isLoading,"loading-error":_vm.loadingError,"no-content":_vm.noContent,"go-back-btn":_vm.goBack,"title":"Information"}},[_c('v-blacker-table',{attrs:{"headers":_vm.notificationsHistoryHeaders,"items":_vm.notificationsHistory},scopedSlots:_vm._u([{key:"jobId",fn:function(ref){
var jobId = ref.item.jobId;
return [_c('router-link',{staticClass:"blue--text",attrs:{"to":{
          name: 'job',
          params: { id: jobId },
          query: { suffix: _vm.suffix },
        }}},[_vm._v(" "+_vm._s(jobId)+" ")])]}},{key:"basketId",fn:function(ref){
        var basketId = ref.item.basketId;
return [_c('router-link',{staticClass:"blue--text",attrs:{"to":{
          name: 'basket',
          params: { id: basketId },
          query: { suffix: _vm.suffix },
        }}},[_vm._v(" "+_vm._s(basketId)+" ")])]}},{key:"created",fn:function(ref){
        var created = ref.item.created;
return [_c('pb-date-time',{attrs:{"date":created}})]}},{key:"accepted",fn:function(ref){
        var accepted = ref.item.accepted;
return [_c('pb-date-time',{attrs:{"date":accepted}})]}}])}),_c('v-blacker-pagination',{attrs:{"items-count":_vm.pagedItemsCount},model:{value:(_vm.pageNum),callback:function ($$v) {_vm.pageNum=$$v},expression:"pageNum"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }